'use strict';
const angular = require('angular');

export class SidebarActivityComponent {
  menu = [{
    title: 'Home',
    url: 'main'
  }];

  isCollapsed = true;

  constructor($state, $scope, $rootScope, fetch) {
    'ngInject';

    this.$state = $state;
    this.$scope = $scope;
    this.fetch = fetch;

    /**
     * Updates the information in Map Side Bar on clicking an individual parcel
     * @param {*} data - passed via the click event to the function
     */
   

  }

  $onInit(){
 
  }


}

export default angular.module('appApp.sidebaractivity', [])
  .directive('sidebaractivity', function() {
    return {
      template: require('./sidebaractivity.html'),
      restrict: 'EA',
      controller: SidebarActivityComponent,
      controllerAs:'sidebarActivityCtrl',
      link: function(scope, element, attrs) {}
    };
  })
  .name;



// WEBPACK FOOTER //
// ./client/components/directives/sidebaractivity/sidebaractivity.directive.js